import React from 'react'
import { MuiIconButton } from '../../components'
import { MavenMagnetLogo } from '../../assets/img'
import { Logout, Theme } from '../../assets/img/icons'
import { consoleLog } from '../../util'
import { useGlobalStore } from '../../store'
import { HeaderWrapper, InfoWrapper, UserName } from './style'
import { NavLink } from 'react-router-dom'

export const LayoutHeader = () => {
  const { theme, setTheme } = useGlobalStore()
  const { user } = useGlobalStore()

  const logoutFunc = () => {
    consoleLog('logoutFunc')
  }
  const changeThemeFunc = () => {
    setTheme(theme === 'light' ? 'dark' : 'light')
  }

  return (
    <HeaderWrapper>
      <MavenMagnetLogo color={theme} />
      <InfoWrapper>
        <UserName>{user?.UserEmail || user?.EmailAddress}</UserName>
        <MuiIconButton onClick={changeThemeFunc}><Theme /></MuiIconButton>
        <NavLink to='/'><MuiIconButton onClick={logoutFunc}><Logout /></MuiIconButton></NavLink>
      </InfoWrapper>
    </HeaderWrapper>
  )
}
